import template from "./loader.html";
import "./loader.scss";

export const loaderComponent = {
    template
};



// WEBPACK FOOTER //
// ./sources/components/common/loader/loader.component.js